'use client'

// lib files
import { usePersonalizedResourceFetch } from '@/lib/hooks/usePersonalizedResource';
import { myListVideos } from '@/lib/resources/my-list-videos';

function NetworkMyListVideos() {
  usePersonalizedResourceFetch(myListVideos)

  return (<></>)
}

export default NetworkMyListVideos
